(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335],{

/***/ 93328:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(7698);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56168);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62044);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9180);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46323);
/* harmony import */ var _enums_namespaces__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99731);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1984);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var helpers_jsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28808);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52662);
/* harmony import */ var _enums_country__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72473);

// @ts-ignore









var Contact = function(param) {
    var countryCode = param.countryCode;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_enums_namespaces__WEBPACK_IMPORTED_MODULE_4__/* .Namespace.Contact */ .l.Contact).t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_5___default()), {
                children: (0,helpers_jsx__WEBPACK_IMPORTED_MODULE_6__/* .basicSEO */ .F)(t("seo:contact_title"), t("seo:contact_description"))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().contact),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().sectionWrapper),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().heading),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        children: t("authorship_provider")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("address", {
                                        children: [
                                            countryCode === _enums_country__WEBPACK_IMPORTED_MODULE_8__/* .Country.Ukraine */ .c.Ukraine ? t("ua_company") : t("company"),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            countryCode === _enums_country__WEBPACK_IMPORTED_MODULE_8__/* .Country.Ukraine */ .c.Ukraine ? t("ua_address") : t("address"),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            countryCode === _enums_country__WEBPACK_IMPORTED_MODULE_8__/* .Country.Ukraine */ .c.Ukraine ? t("ua_ico") : t("ico")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "mailto:".concat(countryCode === _enums_country__WEBPACK_IMPORTED_MODULE_8__/* .Country.Ukraine */ .c.Ukraine ? t("ua_cooperation") : t("cooperation")),
                                        target: "_blank",
                                        children: countryCode === _enums_country__WEBPACK_IMPORTED_MODULE_8__/* .Country.Ukraine */ .c.Ukraine ? t("ua_cooperation") : t("cooperation")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                children: countryCode !== _enums_country__WEBPACK_IMPORTED_MODULE_8__/* .Country.Ukraine */ .c.Ukraine ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().img),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: "/jpg/img-zavadil.jpg",
                                                        width: 270,
                                                        height: 320
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    children: t("contact_ceo")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: t("person_title_1")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "mailto:martin@dramox.cz",
                                                    target: "_blank",
                                                    children: "martin@dramox.cz"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().img),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: "/jpg/img-hajek.jpg",
                                                        width: 270,
                                                        height: 320
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    children: t("contact_cofounder")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: t("person_title_3")
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().img),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                srcSet: "/jpg/img-olia.jpg 1x, /jpg/img-olia@2x.jpg 2x",
                                                src: "/jpg/img-olia.jpg",
                                                width: 270,
                                                height: 320
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            children: t("ua_contact")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            children: t("ua_contact_name")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "mailto:olia.shylo@dramox.tv",
                                            target: "_blank",
                                            children: "olia.shylo@dramox.tv"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().press),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: t("press_media")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: t("press_text")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                target: "_blank",
                                href: "https://drive.google.com/drive/folders/1lRCXvMveQ6c9k83I3i6OFF-GeVeg9yNZ?usp=drive_link",
                                children: t("press_download")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,context__WEBPACK_IMPORTED_MODULE_7__/* .withForcePlanToLoggedInUnsubs */ .DE)(Contact));


/***/ }),

/***/ 9180:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contact":"contact_contact__l89rH","sectionWrapper":"contact_sectionWrapper__JLFxz","heading":"contact_heading__4de5b","img":"contact_img__4VFjj","press":"contact_press__PzE6j"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(93328); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);